var character = "Karakter";
var copied = "Disalin";
var copy = "Salin";
var insert = "Masukkan";
var loading = "muat turun";
var orCopyLink = "Atau salin pautan";
var submit = "Hantar";
var msTranslations = {
	"actionPopover.delete": "Padam",
	"actionPopover.deleteNotification": "Padam notifikasi ini",
	"actionPopover.edit": "Sunting",
	"actionPopover.inviteShareCommunity": "Jemput / Kongsi Komuniti",
	"actionPopover.joinCommunity": "Sertai Komuniti",
	"actionPopover.leaveCommunit": "Keluar Komuniti",
	"actionPopover.leaveCommunity": "Sertai Komuniti",
	"actionPopover.leaveCommunity.accept": "Keluar",
	"actionPopover.leaveCommunity.cancel": "Batal",
	"actionPopover.leaveCommunity.description": "Anda pasti mahu keluar dari komuniti ini?",
	"actionPopover.leaveCommunity.title": "Keluar Komuniti",
	"actionPopover.report": "Laporkan",
	"actionPopover.turnOffNotification": "Matikan notifikasi",
	"actionPopover.turnOffNotificationAbout": "Matikan notifikasi tentang {label}",
	"actionPopover.turnOnNotification": "Hidupkan notifikasi",
	"adBanner.title": "Iklan",
	"admin.comments": "Komen",
	"admin.communities": "Komuniti",
	"admin.community": "Komuniti",
	"article.shareOn": "kongsikan",
	"articleAuthor.title.expert": "Disemak secara pakar oleh",
	"articleAuthor.title.fact-check": "Fakta Disemak oleh {name}",
	"articleAuthor.title.medical": "Disemak secara perubatan oleh",
	"articleAuthor.title.written-by": "Ditulis oleh",
	"articlePage.articleReviewerBy": "Maklumat perubatan disemak oleh {name}",
	"articlePage.readMore": "Baca Lagi",
	"articlePage.showLess": "Tutup",
	"babyGrowth.alert.bmi": "\nTiada bacaan BMI untuk {name} dalam julat WHO bagi kanak-kanak yang berumur antara 0 ke 5 tahun. Gunakan kalkulator BMI untuk kanak-kanak yang berumur di atas 5 tahun",
	"babyGrowth.alert.head": "Tiada bacaan ukur lilit kepala untuk {name} dalam julat WHO bagi kanak-kanak yang berumur antara 0 ke 5 tahun",
	"babyGrowth.alert.weight": "Tiada bacaan berat badan untuk {name} dalam julat WHO bagi kanak-kanak yang berumur antara 0 ke 10 tahun",
	"babyGrowth.babyInfo": "Maklumat Bayi",
	"babyGrowth.chartTitle": "WHO - {name} Graf Tumbesaran",
	"babyGrowth.chartTitle.noName": "Graf tumbesaran bayi anda",
	"babyGrowth.cm": "cm",
	"babyGrowth.drawer.addMeasurement": "Masukkan ukuran",
	"babyGrowth.drawer.createBaby": "Cipta profil anak",
	"babyGrowth.drawer.switchProfile": "Tukar profil",
	"babyGrowth.emptyName": "bayi anda",
	"babyGrowth.error.atLeastOneOf": "Satu daripada item berikut perlu diisi: Berat, Tinggi, Ukur Lilit Kepala",
	"babyGrowth.error.birthdayRequired": "Tarikh lahir diperlukan",
	"babyGrowth.error.invalidAge": "Bacaan melebihi umur",
	"babyGrowth.error.invalidMeasurementDate": "Hari yang dipilih tidak tepat",
	"babyGrowth.error.invalidValue": "Isikan info yang tepat",
	"babyGrowth.error.measurementDateLowerThanBirthday": "Tarikh yang dipilih ialah sebelum tarikh lahir anak anda",
	"babyGrowth.error.outOfRange": "Bacaan melebihi julat WHO",
	"babyGrowth.error.title": "Data tidak tepat",
	"babyGrowth.head": "Kepala",
	"babyGrowth.headCircumference": "Ukur Lilit Kepala",
	"babyGrowth.height": "Tinggi",
	"babyGrowth.input.babyName": "Nama Anak",
	"babyGrowth.input.birthday": "Tarikh lahir bayi",
	"babyGrowth.input.bmi": "BMI",
	"babyGrowth.input.bodyMass": "Jisim badan",
	"babyGrowth.input.checkSubmit": "Pantau tumbesaran anak anda",
	"babyGrowth.input.measurementDate": "Tarikh ukuran dilakukan",
	"babyGrowth.input.submit": "Pantau Tumbesaran Anak Anda",
	"babyGrowth.kg": "kg",
	"babyGrowth.kg.m2": "kg/m2",
	"babyGrowth.monthly": "Bulanan",
	"babyGrowth.nickname": "Nama panggilan",
	"babyGrowth.optional": "(tidak wajib diisi)",
	"babyGrowth.pageTitle": "Keputusan anak anda",
	"babyGrowth.percentiles": "Persentil",
	"babyGrowth.placeholder.babyName": "Isikan nama anak anda",
	"babyGrowth.popup.heading": "Profil Bayi",
	"babyGrowth.reCalculate": "Kira semula",
	"babyGrowth.record": "Data Tersimpan",
	"babyGrowth.save": "Simpan data",
	"babyGrowth.save.loggedIn": "Lihat Graf Tumbesaran {name} ",
	"babyGrowth.weekly": "Mingguan",
	"babyGrowth.weight": "Berat ",
	"babyGrowth.xLabel": "Umur ({recurrence})",
	"babyGrowth.yearly": "Tahunan",
	"babyPoop.findOut": "Ketahui",
	"babyPoopTool.name": "Najis bayi",
	"babyVaccine.banner.readmore": "Baca lagi",
	"babyVaccine.detail.benifit": "Kebaikan",
	"babyVaccine.detail.contraindication": "Kontraindikasi",
	"babyVaccine.detail.definition": "Definisi",
	"babyVaccine.detail.relatedArticles": "Artikel Berkaitan",
	"babyVaccine.immunization.vaccineName": "Nama vaksin",
	"babyVaccine.immunization.warning": "Statik imunisasi mudah dibaca dan mesra ibu bapa kerana ia sama dengan garis masa vaksinasi bayi anda",
	"babyVaccine.popup.button": "Cipta profil baharu",
	"babyVaccine.popup.button.submit": "Simpan",
	"babyVaccine.popup.checkbox.suggestedDate": "Pilih tarikh yang ditetapkan atau kekalkan cadangan di bawah",
	"babyVaccine.popup.confirm.close": "Tukar tarikh",
	"babyVaccine.popup.confirm.description": "Bayi anda telah menerima suntikan vaksin ini pada {date}",
	"babyVaccine.popup.confirm.ok": "Sahkan",
	"babyVaccine.popup.confirm.title": "Tarikh vaksinasi",
	"babyVaccine.popup.input.suggestedDate": "Saya tidak ingat / Tetapkan tarikh yang disarankan",
	"babyVaccine.popup.label.doses": "Dos",
	"babyVaccine.popup.tab.benefits": "Manfaat",
	"babyVaccine.popup.tab.contraindication": "Kontraindikasi",
	"babyVaccine.popup.tab.detail": "Maklumat lanjut",
	"babyVaccine.popup.tab.schedule": "Jejaki",
	"babyVaccine.popup.title": "Maklumat vaksin",
	"babyVaccine.status.all": "Semua",
	"babyVaccine.status.missed": "Terlepas ",
	"babyVaccine.status.next": "Selanjutnya",
	"babyVaccine.status.upcoming": "Akan datang",
	"babyVaccine.status.vaccinated": "Sudah divaksin",
	"babyVaccine.timeline.antigen": "Antigen:",
	"babyVaccine.timeline.atBirth": "semasa Lahir",
	"babyVaccine.timeline.total": "Jumlah: {number} Dos",
	"babyVaccine.timeline.totalNext": "{number} Dos Akan Datang",
	"babyVaccine.timeline.totalPast": "{number} Dos Yang Lalu",
	"babyVaccine.vaccineCard.injected": "Disuntik",
	"babyVaccine.vaccineCard.markAsInjected": "Tanda sebagai sudah disuntik",
	"babyVaccine.vaccineInfo.dose": "Dos: {ordinal}/{total}",
	"babyVaccine.vaccineInfo.injectedDate": "Tarikh suntikan: {date}",
	"babyVaccine.vaccineInfo.mandatory": "Wajib",
	"babyVaccine.vaccineInfo.optional": "Pilihan",
	"babyVaccine.vaccineInfo.suggested": "Rekomendasi tarikh: {date}",
	"babyVaccineTool.heading": "Jadual Vaksin Bayi",
	"bmi.ageInput": "Berapa umur anda?",
	"bmi.ageInput.desc": "(tahun)",
	"bmi.ageInput.error": "Masukkan umur yang sah.",
	"bmi.heading": "Kalkulator BMI",
	"bmi.heightInput": "Berapa ketinggian anda?",
	"bmi.heightInput.desc": "(cm)",
	"bmi.heightInput.error": "Sila masukkan ketinggian yang sah",
	"bmi.objective": "Objektif",
	"bmi.objective.gainWeight": "Membina otot",
	"bmi.objective.loseWeight": "Menurunkan berat badan",
	"bmi.objective.maintainWeight": "Mengekalkan berat badan",
	"bmi.result.healthy": "Berat Badan Sihat",
	"bmi.result.overweight": "Berat Badan Berlebihan",
	"bmi.result.underweight": "Kurang Berat Badan",
	"bmi.selectGender": "Apakah jantina anda?",
	"bmi.submit": "Kira",
	"bmi.weightInput": "Berapakah berat badan anda?",
	"bmi.weightInput.desc": "(kg)",
	"bmi.weightInput.error": "Masukkan berat badan yang sah.",
	"bmr.heading": "Kalkulator BMR",
	"booking.searchBar.allLocations": "Semua Lokasi",
	"booking.searchBar.allSpecialties": "Semua Bidang Kepakaran",
	"booking.searchBar.currentLocation": "lokasi semasa",
	"booking.searchBar.grantLocation": "Sila berikan kebenaran lokasi untuk mendapatkan hasil carian kawasan berdekatan",
	"booking.searchBar.locationPlaceholder": "Bandar",
	"booking.searchBar.noResults": "Tiada hasil",
	"booking.searchBar.placeholder.doctor": "Cari mengikut nama doktor",
	"booking.searchBar.placeholder.hospital": "Cari mengikut nama hospital",
	"booking.searchBar.placeholder.service": "Cari mengikut perkhidmatan",
	"booking.searchBar.placeholder.specialty": "Cari mengikut kepakaran",
	"booking.searchBar.popularKey": "Carian Kunci Popular",
	"booking.searchBar.searchButton": "Cari",
	"booking.searchBar.searchInput.placeholder": "Cari mengikut kepakaran atau klinik",
	"booking.searchBar.useCurrentLocation": "Gunakan lokasi semasa",
	"booking.searchBar.viewAll": "Lihat Semua",
	"booking.searchPopup.doctors": "Doktor",
	"booking.searchPopup.hospitals": "Hospital & Klinik",
	"booking.searchPopup.searchIn.doctors": "Cari \"{name}\" dari senarai Doktor",
	"booking.searchPopup.searchIn.hospitals": "Cari \"{name}\" dari senarai hospital",
	"booking.searchPopup.searchIn.services": "Cari \"{name}\" dari senarai perkhidmatan",
	"booking.searchPopup.searchIn.specialties": "Cari \"{name}\" dari senarai kepakaran",
	"booking.searchPopup.seeAll": "Lihat semua",
	"booking.searchPopup.seeLessSpecialties": "Sembunyi kepakaran",
	"booking.searchPopup.seeMoreSpecialties": "Lihat semua kepakaran",
	"booking.searchPopup.services": "Perkhidmatan",
	"booking.searchPopup.specialties": "Kepakaran",
	"booking.searchResult.description": "{search_type} di {search_location}",
	"bottomBar.share": "Kongsi",
	"cardAuthor.admin": "Admin",
	"cardAuthor.ambassador": "Duta",
	"cardAuthor.expert": "Pakar",
	"cardAuthor.guide": "Panduan",
	"cardAuthor.influencer": "Influencer",
	"cardAuthor.localAdmin": "Admin Lokal",
	"cardAuthor.moderator": "Moderator",
	"cardAuthor.sponsor": "Penaja",
	"cardPost.anonymous": "Rahsia Identiti",
	"cardPost.option.anonymous": "Tanpa nama",
	"cardPost.public": "Awam",
	"cardReactions.comment": "Komen",
	"cardReactions.like": "Suka",
	"cardReactions.repliesCount": "{kira} balasan",
	"cardReactions.reply": "Balas",
	"cardReactions.save": "Simpan",
	"cardReactions.unSave": "Tidak Simpan ",
	"cardReply.disclaimer": "Penafian: Kandungan ini disediakan berdasarkan sumber maklumat yang disahkan",
	"cardReply.endorse": "Sokong",
	"cardReply.opposePopup.content": "Sila berikan sebab untuk membantah jawapan ini",
	"cardReply.opposePopup.submit": "Hantar",
	"cardReply.pppose": "Bantah",
	"cardReply.recommentCategories.heading": "Topik berkaitan",
	"cardReply.source": "sumber",
	"cardReply.verifyBy": "Disemak secara perubatan oleh",
	"careBooking.bookAnAppointment": "Buat temu janji",
	"categoryPage.info.reviewed": "Disemak secara perubatan oleh",
	"categoryPage.onDate": "pada {date}",
	character: character,
	"chatbot.with.me": "Berbual dengan saya",
	"childCard.age.months": "{month} bulan",
	"childCard.age.oneMonth": "1 bulan",
	"childCard.age.oneWeek": "1 minggu",
	"childCard.age.oneYear": "1 tahun",
	"childCard.age.oneYearMonth": "1 tahun {month} bulan",
	"childCard.age.oneYearOneMonth": "1 tahun 1 bulan",
	"childCard.age.week": "{weeks} minggu",
	"childCard.age.yearMonth": "{year} tahun {month} bulan",
	"childCard.age.yearNoMonth": "{year} tahun",
	"childCard.age.yearOneMonth": "{year} tahun 1 bulan",
	"childCard.boy": "Lelaki",
	"childCard.girl": "Perempuan",
	"childCard.menu.add": "Tambah profil anak",
	"childCard.menu.edit": "Edit profil {name}",
	"childCard.menu.remove": "Buang profil {name}",
	"childCard.menu.switch": "Tukar profil anak",
	"childCard.noName": "Nama Anak",
	"choicePopover.ambassadorPosts": "Siaran Duta",
	"choicePopover.expertPosts": "Siaran Pakar",
	"choicePopover.lastestPost": "Siaran terbaharu",
	"choicePopover.latest": "Terkini",
	"choicePopover.newest": "Terbaharu",
	"choicePopover.oldest": "Terawal",
	"choicePopover.popular": "Popular",
	"choicePopover.popularPost": "Kiriman Popular",
	"choicePopover.sort": "Susun",
	"choose.community": "Pilih komuniti anda",
	"choose.other.community": "Pilih komuniti lain",
	"chooseBaby.button": "Lihat Graf Tumbesaran Anak Anda",
	"chooseBaby.new": "atau Tambah profil anak yang baru",
	"chooseBaby.placeholder": "Sila berikan nama anak anda",
	"chooseBaby.title": "Pilih profil anak",
	"comment.count": "{count} komen",
	"comment.now": "Komen sekarang",
	"comment.seeMoreComments": "Lihat {count} lagi komen ",
	"comment.seeMoreReplies": "Lihat {count} lebih maklum balas",
	"commentPopup.warning.newPost": "Soalan anda akan disiarkan secara umum",
	"common.playing": "Dimainkan..",
	"common.profileNavigator.newsletterSubscription": "Langganan Buletin",
	"common.sponsoredBy": "Ditaja Oleh",
	"common.totalView": "{number} tontonan",
	"community.choose": "Pilih komuniti",
	"community.notification.joined": "Anda sudah menyertai komuniti {name}",
	"community.notification.left": "Anda sudah keluar dari komuniti {name}",
	copied: copied,
	copy: copy,
	"createPost.askDoctor": "Tanya Doktor",
	"createPost.askDoctor.description": "Dapatkan nasihat daripada pakar kami",
	"createPost.askDoctorChoice.no": "Tidak",
	"createPost.askDoctorChoice.yes": "Ya",
	"createPost.communityAndTopic": "Komuniti & Topik",
	"createPost.message.askDoctorRequire": "Ingin bertanya kepada doktor kami?",
	"createPost.message.askDoctorRequireMess": "Sila pilih satu pilihan",
	"createPost.message.lengthDescription": "Deskripsi mesti mengandungi sekurang-kurangnya 10 perkataan | Kini: {currentLength} perkataan",
	"createPost.message.lengthTitle": "Tajuk mesti mengandungi sekurang-kurangnya 5 perkataan",
	"createPost.message.lengthTitle.characters": "Tajuk mestilah sekurang-kurangnya 5 aksara.",
	"createPost.message.photoMaxium": "Maksimum 10 imej semasa memuat naik imej untuk siaran",
	"createPost.message.photoSize": "Hanya dibenarkan memuat naik imej bersaiz <= 10 MB",
	"createPost.message.requiredDescription": "Penerangan diperlukan",
	"createPost.message.requiredTitle": "Tajuk diperlukan",
	"createPost.message.suggestLoading": "Kami sedang mencadangkan komuniti yang relevan untuk pos anda",
	"createPost.message.suggestResult": "Anda boleh pos sekarang! Kami akan terus mencari komuniti yang relevan selepas itu",
	"createPost.now": "Pos sekarang",
	"createPost.photos": "Foto",
	"createPost.popup.description": "Penerangan",
	"createPost.popup.guideSelectMonthTopics": "Pilih topik tentang bulan kelahiran bayi anda",
	"createPost.popup.guideSelectTopics": "Pilih topik, tempat untuk menyiarkan artikel anda",
	"createPost.popup.primary": "Klik untuk pilih/nyahpilih topik",
	"createPost.popup.selectMonthTopicBtn": "Pilih",
	"createPost.popup.specialCharErr": "Tajuk yang anda masukkan tidak sah. Tajuk mesti mengandungi huruf.",
	"createPost.popup.submit": "Siaran",
	"createPost.popup.success": "Siaran baru",
	"createPost.popup.warning": "Pilih komuniti untuk lihat topik yang diikuti",
	"createPost.popup.warningImage": "Maksimum 20 gambar sahaja, sila buang beberapa gambar di bawah",
	"createPost.popup.wordCount": "{count}/{max} perkataan",
	"createPost.post.askDoctor.description": "Huraikan gejala",
	"createPost.post.askDoctor.title": "Symptom name",
	"createPost.post.description": "Deskripsi pos",
	"createPost.post.title": "Tajuk pos",
	"createPost.postAnonymous": "Siarkan Tanpa Nama (Anonymous) ",
	"createPost.title": "Tajuk",
	"createPost.urlText": "Teks",
	"createPost.video": "Video",
	"createPost.videoOrLink": "Video atau pautan",
	"dueDatePage.IUI": "Inseminasi dalam rahim (IUI)",
	"dueDatePage.calculationMethod": "Kaedah Pengiraan",
	"dueDatePage.conceptionDate": "Tarikh Konsepsi",
	"dueDatePage.date_of_IUI_procedure": "Tarikh prosedur IUI",
	"dueDatePage.date_of_ultrasound": "Tarikh Ultrasound",
	"dueDatePage.daysText": "{number} hari",
	"dueDatePage.ivf": "IVF",
	"dueDatePage.ivf.transferDate": "Tarikh Pemindahan IVF",
	"dueDatePage.ivf.transferDateRadio": "{number} Hari Dipindah",
	"dueDatePage.lastPeriod": "Haid Terakhir",
	"dueDatePage.lastPeriod.calculate": "Kira",
	"dueDatePage.lastPeriod.lastPeriodLabel": "Hari pertama haid terakhir anda",
	"dueDatePage.lastPeriod.periodLengthLabel": "Panjang Kitaran",
	"dueDatePage.ultrasound": "Ultrasound",
	"dueDatePage.ultrasound.tooltip": "Mean sac Diameter (MSD) adalah kurang tepat daripada Crown-Rump Length (CRL) untuk tarikh kehamilan. Ia hanya digunakan dalam kehamilan yang sangat awal, antara 4 dan 6 minggu.",
	"dueDatePage.validation.crl": "Nilai MSD tidak sah. Sila masukkan metrik CRL untuk meneruskan.",
	"dueDatePage.validation.one_is_required": "Sekurang-kurangnya satu diperlukan",
	"dueDatePage.validation.record_not_valid": "Rekod anda tidak sah!",
	"editor.addSocialLink.addLink": "Tambah",
	"editor.addSocialLink.warningDomain": "Hanya membenarkan sumber dari Youtube, Facebook, dan Tiktok",
	"expert.content.description": "Profil",
	"expert.content.experiences": "Pengalaman",
	"footer.signUp": "Daftar Masuk Sekarang",
	"gender.boy": "Lelaki",
	"gender.female": "Wanita",
	"gender.girl": "Perempuan",
	"gender.male": "Lelaki",
	"healthToolPNModal.back": "Kembali",
	"healthToolPNModal.findMore.chooseFav": "Pilih dari topik kegemaran anda",
	"healthToolPNModal.finish": "Selesai",
	"healthToolPNModal.heading": "Ingin menerima buletin mingguan percuma?",
	"healthToolPNModal.mainForm.requireName": "Masukkan nama Anda",
	"healthToolPNModal.mainForm.tailorTopicsHeading": "Topik ini dikhaskan mengikut keputusan anda",
	"healthToolPNModal.next": "Seterusnya",
	"healthToolPNModal.register": "Daftar",
	"healthToolPNModal.yourPre": "Keutamaan anda",
	"healthTools.dueDateCalculator": "Kalkulator Tarikh Bersalin",
	"healthTools.ovulationCalculator": "Kalkulator Ovulasi",
	"healthtool.placeholder.age": "Umur anda",
	"home.calcWithApp": "Kira menggunakan aplikasi Hello Doktor",
	"home.menu.category.view": "Lihat {category}",
	"home.navigator.app": "Aplikasi",
	"home.navigator.downloadApp": "muat turun aplikasi",
	"home.navigator.menu.care.homeButton": "Halaman Tempahan",
	"home.navigator.menu.care.noDatas.cta": "Tempah Janji Temu Doktor",
	"home.navigator.menu.care.noDatas.description": "HelloCare membantu pesakit untuk mencari doktor atau perkhidmatan kesihatan yang sesuai dan berhampiran dengan mereka.",
	"home.navigator.menu.care.noDatas.title": "Jadualkan janji temu untuk berjumpa doktor dengan mudah",
	"home.navigator.menu.category.noDatas.cta": "Lihat Sekarang",
	"home.navigator.menu.category.noDatas.description": "Hello Doktor mahu menjadi rakan kongsi anda yang paling dipercayai untuk membuat lebih banyak keputusan yang tepat bersama, dan hidup dengan lebih sihat lagi bahagia.",
	"home.navigator.menu.category.noDatas.title": "Selamat Datang ke Hello Doktor",
	"home.navigator.menu.healthTools.noDatas.cta": "Lihat Selanjutnya",
	"home.navigator.menu.healthTools.noDatas.description": "Alat-alat kesihatan ini mudah untuk digunakan bagi memantau tahap kesihatan anda.",
	"home.navigator.menu.healthTools.noDatas.title": "Alat Kesihatan",
	"home.navigator.menu.lastestVideos": "Shorts Terkini",
	"home.navigator.menu.podcasts": "Podcast",
	"home.navigator.menu.shorts": "Shorts",
	"home.navigator.menu.spotlightEcom": "Kategori",
	"home.navigator.menu.spotlightHospitals": "Hospital Popular",
	"home.navigator.menu.spotlightTools": "Alat Kesihatan Kegemaran",
	"home.navigator.menu.spotlights": "Semua Spotlight",
	"home.navigator.menu.spotlights.seeAll": "Lihat Semua Spotlight",
	"home.navigator.menu.together.noPosts.cta": "Sertai Komuniti Kami",
	"home.navigator.menu.together.noPosts.description": "Komuniti merupakan platform selamat untuk anda berhubung dengan ahli lain, meinggalkan komen megenai topik yang anda pilih dan mendapatkan nasihat perubatan daripada pakar kesihatan kami. ",
	"home.navigator.menu.together.noPosts.title": "Selamat Datang Ke Komuniti",
	"home.navigator.menu.trendingPosts": "Posting Utama",
	"home.navigator.menu.trendingPosts.seeMore": "Lihat Lagi",
	"home.navigator.menu.videos": "Video",
	"home.navigator.menuItem.allCategories": "Lihat Semua Kategori",
	"home.navigator.menuItem.allCommunities": "Lihat semua komuniti",
	"home.navigator.menuItem.allCommunitiesheadingTitle": "Cari komuniti anda",
	"home.navigator.menuItem.allHealthTools": "Lihat Semua Alat Kesihatan",
	"home.navigator.menuItem.allSpecialties": "Semua kepakaran",
	"home.navigator.menuItem.allSpotlight": "Lihat Semua Spotlight",
	"home.navigator.menuItem.allVideos": "See All Videos",
	"home.navigator.menuItem.discover": "Info Kesihatan",
	"home.navigator.menuItem.healthCategories": "Kategori Kesihatan",
	"home.navigator.menuItem.healthTools": "Alat Kesihatan  ",
	"home.navigator.menuItem.healthToolsList": "Alat Kesihatan",
	"home.navigator.menuItem.helloCare": "Booking Doktor",
	"home.navigator.menuItem.helloEcom": "Farmasi",
	"home.navigator.menuItem.helloTogether": "Komuniti",
	"home.navigator.menuItem.language": "Bahasa",
	"home.navigator.menuItem.new": "Baru",
	"home.navigator.menuItem.specialties": "Kepakaran",
	"home.navigator.menuItem.spotlights": "Semua Spotlight",
	"home.navigator.menuItem.video": "Video",
	"home.navigator.menuItem.videoCategories": "Video Categories",
	"home.search": "Cari {site}",
	"home.seeAll": "Lihat Semua",
	"home.seeAllCategories": "Lihat Semua Topik",
	"home.seeExpert": "Lihat Profil Penuh Pakar",
	"home.seeHospital": "Lihat Profil Penuh Hospital",
	"home.seeMore": "Lihat Lebih Lagi",
	"home.seeMoreExperts": "Lihat Lebih Ramai Pakar",
	"hospital.content.description": "Informasi hospital",
	"inputComment.replyTo": "Balas ke {name}",
	insert: insert,
	"label.latestPost": "Kiriman terkini",
	"label.pinnedPost": "Kiriman Terpilih",
	"lead.empty.cancel": "Batal",
	"lead.empty.submitAgain": "Hantar semula",
	"lead.empty.title": "Oops, nampaknya maklumat anda kosong. Adakah anda ingin menghantar maklumat semula?",
	"leadgen.message.error.name_required": "Please enter your name",
	"leadgen.message.error.phone_invalid": "Please enter a valid phone number",
	loading: loading,
	"login.booking": "Booking Doktor",
	"logout.popup.ask.mb": "Logout of Marry Baby",
	"logout.popup.ask1": "Log Keluar Dari Hello Doktor?",
	"logout.popup.ask2": "Anda pasti?",
	"logout.popup.button.cancel": "Batal",
	"logout.popup.button.logout": "Log Keluar",
	"menu.care.searchBySpecialties": "Cari berdasarkan kepakaran",
	"morePopover.report": "Laporkan",
	"morePopover.report.description": "Bantu kami untuk mengenal pasti apa masalah kiriman ini. Nyatakan ketidakpuasan hati anda.",
	"morePopover.report.falseNews": "Berita palsu",
	"morePopover.report.offensive": "Menyerang pihak lain",
	"morePopover.report.other": "Lain-lain",
	"morePopover.report.prohibited": "Kandungan terlarang",
	"morePopover.report.scam": "Mengelirukan atau penipuan",
	"morePopover.report.sex": "Berunsur seksual",
	"morePopover.report.spam": "Spam",
	"morePopover.report.title": "Laporkan kiriman ini",
	"morePopover.report.violence": "Kekejaman",
	"morePopover.reportSubmit.description": "Kami tidak akan mendedahkan identiti anda. Sila periksa butiran berikut:",
	"morePopover.reportSubmit.title": "Hantar laporan?",
	"morePopover.savePost": "Simpan kiriman",
	"morePopover.share": "Kongsi",
	"morePopover.shareOn": "Kongsikan ke",
	"morePopover.turnOffNotifications": "Matikan notifikasi",
	"morePopover.turnOnNotifications": "Hidupkan notifikasi",
	"morePopover.unsavePost": "Buang siaran tersimpan",
	"navigation.loginJoin": "Log Masuk",
	"navigation.search.input.placeholder": "Cari",
	"navigation.signUp": "Daftar masuk",
	"newsletter.error.minCotennt": "Pilih sekurang-kurangnya 1 topik untuk meneruskan tindakan ini",
	"newsletter.error.minTitle": "Minimum 1 topik dicapai",
	"newsletter.topic.title": "Apakah topik kesihatan yang anda minati?",
	"newsletter.welcome.description": "Apa nama panggilan anda?",
	"notification.comment.blocked.message": "Komen ini mengandungi perkataan atau frasa yang dilarang dan tidak akan diterbitkan",
	"notification.comment.blocked.title": "Komen disekat",
	"notification.comment.premod": "Komen anda akan disemak terlebih dahulu.",
	"notification.comment.rejected": "Komen anda mengandungi perkataan yang tidak dibenarkan.",
	"notification.comment.reportFailed": "Gagal!",
	"notification.comment.reportSuccess": "Anda telah berjaya melaporkan komen.",
	"notification.comment.somethingWrong": "Terdapat masalah teknikal",
	"notification.comment.suspect.message": "Komen ini mengandungi perkataan atau frasa yang mencurigakan dan tidak akan diterbitkan",
	"notification.comment.suspect.title": "Komen dalam proses",
	"notification.comment.systemWithheld": "Komen anda akan disemak terlebih dahulu.",
	"notification.failure": "Terdapat masalh teknikal. Sila cuba lagi!",
	"notification.limitUrlDomain": "Tidak boleh memuat naik pautan di luar Hello Health Group",
	"notification.post.blocked.message": "Siaran ini mengandungi perkataan atau ungkapan yang dilarang dan tidak dapat diterbitkan",
	"notification.post.blocked.title": "Siaran dilarang",
	"notification.post.delete": "Kiriman dipadam",
	"notification.post.suspect.message": "Siaran ini mengandungi perkataan yang meragukan, dan akan disemak oleh moderator",
	"notification.post.suspect.title": "Siaran dalam proses",
	"notification.success": "Berjaya",
	"notification.suspend.message": "Akaun anda telah digantung kerana telah melanggar terma dan syarat kami",
	"notification.urlWrongFormat": "Format URL tidak betul",
	"onboarding.button.continue": "Teruskan",
	"onboarding.button.skip": "Langkau",
	"onboarding.errorMessage.invalidEmail": "Emel tidak sah",
	"onboarding.errorMessage.minLength": "Sila isi sekurang-kurangnya {length} karakter",
	"onboarding.errorMessage.passNotMatch": "Kata laluan tidak tepat",
	"onboarding.errorMessage.passWithPattern": "Kata laluan mesti mengandungi huruf besar dan huruf kecil",
	"onboarding.errorMessage.requiredConfirmPassword": "Sila isikan kata laluan pengesahan anda",
	"onboarding.errorMessage.requiredEmail": "Sila masukkan emel anda",
	"onboarding.errorMessage.requiredName": "Sila isikan nama anda",
	"onboarding.errorMessage.requiredPassword": "Sila isi kata laluan anda",
	"onboarding.formEmail.description": "Teruskan dengan emel anda untuk ke komuniti {site}",
	"onboarding.formEmail.genderFemale": "Perempuan",
	"onboarding.formEmail.genderMale": "Lelaki",
	"onboarding.formEmail.heading": "Bantu kami lebih mengenali anda",
	"onboarding.formEmail.yourBirthday": "Tarikh lahir anda",
	"onboarding.formEmail.yourEmail": "Emel anda",
	"onboarding.formEmail.yourName": "Nama anda",
	"onboarding.label.fullName": "Nama penuh",
	"onboarding.otpForm.description": "Kami telah hantar One-Time-Password (OTP) ke nombor telefon anda {phone}",
	"onboarding.otpForm.descriptionEmail": "Kami telah menghantar One-Time Password (OTP) ke emel anda {email}",
	"onboarding.otpForm.error": "Sila masukkan kod OTP yang sah",
	"onboarding.otpForm.heading": "Masukkan OTP anda",
	"onboarding.otpForm.notReceiveOTP": "Tidak menerima kod OTP?",
	"onboarding.otpForm.resendCode": "Hantar Semula Kod",
	"onboarding.otpForm.resendCodeWithSeconds": "Hantar kod semula {seconds}",
	"onboarding.otpWhatsapps.description": "Kami telah menghantar Kata Laluan Sekali Guna (OTP) ke nombor WhatsApp anda {phone}",
	"onboarding.otpWhatsapps.heading": "Pengesahan WhatsApp",
	"onboarding.similac.address.error": "Alamat anda diperlukan",
	"onboarding.similac.input.address": "Alamat",
	"onboarding.similac.input.city": "Pilih Bandar/Daerah",
	"onboarding.similac.input.district": "Pilih Negeri",
	"onboarding.similac.input.no": "Sila masukkan nama jalan, flat/apartment dan nombor rumah",
	"onboarding.similac.input.phone": "Nombor telefon anda",
	"onboarding.similac.input.ward": "Pilih Kawasan Perumahan anda",
	"onboarding.updatePassword.confirmPassword": "Sahkan kata laluan",
	"onboarding.updatePassword.description": "Pastikan ia 8 karakter atau lebih",
	"onboarding.updatePassword.heading": "Hampir siap! Anda perlukan kata laluan",
	"onboarding.updatePassword.password": "Kata laluan",
	"onboarding.updatePasswordResult.description": "Anda boleh log masuk ke akaun Hello Doktor anda dengan kata laluan baru",
	"onboarding.updatePasswordResult.heading": "Ciptaan kata laluan berjaya",
	"onboarding.updatePhone.description": "Kami akan hantar One-Time-Password (OTP) ke nombor telefon anda",
	"onboarding.updatePhone.error": "Sila masukkan nombor telefon yang sah",
	"onboarding.updatePhone.heading": "Nombor telefon anda",
	"onboarding.updateWhatsapp.description": "Whatsapp akan perlu mengesahkan nombor telefon anda.",
	"onboarding.updateWhatsapp.submitLabel": "Teruskan dengan WhatsApp",
	"onboarding.welcomeScreen.content": "Satu ruangan yang terbuka dan mesra di mana anda boleh berkongsi, berhubung dan bertukar sokongan dengan ahli lain untuk mencapai kehidupan yang lebih sihat dan bahagia.",
	"onboarding.welcomeScreen.heading": "Selamat Datang ke Komuniti Hello Doktor",
	orCopyLink: orCopyLink,
	"ovulationPage.avoidPregnancy": "Mengelak kehamilan ",
	"ovulationPage.conceive": "Merancang kehamilan ",
	"ovulationPage.cycleLength": "Tempoh Kitaran",
	"ovulationPage.dayUnit": "hari",
	"ovulationPage.objectives": "Objektif",
	"ovulationPage.periodDuration": "Tempoh haid",
	"ovulationPage.trackPeriod": "Pantau kitaran haid ",
	"placeholder.enterTitleHere": "Masukkan tajuk di sini",
	"placeholder.enterUrlHere": "Masukkan URL di sini",
	"placeholder.enterUrlTextHere": "Masukkan Teks URL di sini",
	"placeholder.newCmt": "Tulis komen",
	"placeholder.newPost": "Mulakan kiriman baru",
	"pnBanner.both": "Keduanya",
	"pnBanner.both.desc": "Selamat datang ke dunia keibubapaan! Pilih alat yang bersesuaian dengan anda.",
	"pnBanner.both.heading": "Jelajahi alat kesihatan untuk ibu bapa!",
	"pnBanner.caclNow": "Kira sekarang",
	"pnBanner.checkNow": "Semak sekarang!",
	"pnBanner.dueDateTool.desc": "Rancang sambutan si kecil lebih awal untuk pengalaman yang bebas tekanan!",
	"pnBanner.dueDateTool.heading": "Jejak Tarikh Jangkaan Lahir",
	"pnBanner.hpv.desc": "Maklum balas anda membantu kami menyediakan cadangan yang khusus untuk keperluan keluarga anda.",
	"pnBanner.hpv.heading": "Lindungi anak perempuan anda dari virus HPV!",
	"pnBanner.parenting.desc": "Maklum balas anda membantu kami menyediakan cadangan yang khusus untuk keperluan keluarga anda.",
	"pnBanner.parenting.heading": "Berapakah lingkungan umur anak anda?",
	"pnBanner.pn.btnLabel": "Buletin Premium",
	"pnBanner.pregnancy.desc": "Masukkan maklumat ini untuk memastikan cadangan kami sesuai dengan perjalanan baharu anda yang mengujakan",
	"pnBanner.pregnancy.heading": "Sedang menjelajahi dunia kehamilan?",
	"pnBanner.submit": "Hantar",
	"pnBanner.teenager": "Remaja",
	"pnBanner.teenager.heading": "Apakah jantina anak-anak anda?",
	"pnBanner.toddlers": "Anak-anak",
	"pnBanner.vaccination.desc": "Lindungi si Kecil dengan jadal vaksinasi yang dikhususkan untuk anda!",
	"pnBanner.vaccination.heading": "Gunakan Penjadual Vaksin Bayi Kami",
	"pnBanner.vaccine.btnLabel": "Jadual Vaksin Bayi",
	"pnModal.disclaimer": "E-mel ringkasan pertama anda sedang dalam perjalanan. Bersedialah untuk menerokai kandungan yang dikhaskan untuk anda!",
	"pnTopicSection.maxSelectError.desc": "Buang sekurang-kurangnya 1 topik untuk meneruskan tindakan ini",
	"pnTopicSection.maxSelectError.detail": "Pilih maksimum {max} topik (<a></a>/{max})",
	"pnTopicSection.maxSelectError.title": "Maksimum 5 topik dicapai",
	"pnTopicSection.notFound": "Tidak dijumpai",
	"pnTopicSection.plsEnterFavTopics": "Masukkan topik kesukaan anda",
	"pnTopicSection.ppAlsoInterested": "Juga Berminat",
	"pnTopicSection.recentView": "Telah dilihat",
	"pnTopicSection.trending": "Terkini",
	"popup.allTopics": "Semua Topik",
	"popup.createPost.confirmCloseDescription": "Jika teruskan, anda akan hilang kiriman ini",
	"popup.createPost.confirmCloseTitle": "Anda pasti?",
	"popup.deleteComment.description": "Delete your comment cannot be undone",
	"popup.deleteComment.title": "Delete comment?",
	"popup.deletePost.accept": "Padam",
	"popup.deletePost.cancel": "Batal",
	"popup.deletePost.description": "Kiriman yang dipadam akan hilang selamanya",
	"popup.deletePost.title": "Padam kiriman?",
	"popup.discardPost": "Kiriman Dibuang",
	"popup.discardPostEdit": "Padam suntingan",
	"popup.editPost": "Sunting kiriman",
	"popup.keepEditing": "Teruskan menyunting",
	"popup.startANewPost": "Mulakan kiriman baru",
	"post.commentCount": "{count} komen",
	"post.likesCount": "{count} tanda suka",
	"post.remove.failed": "Gagal memadam",
	"post.remove.success": "Pos yang disimpan telah dipadam",
	"post.save.failed": "Gagal menyimpan pos",
	"post.save.success": "Pos disimpan",
	"post.seeMore": "Lihat Lebih Lagi",
	"post.shareCount": "{count} kongsi",
	"pregnancy.week": "Minggu",
	"pregnancyTool.description": "Bayi anda kini sebesar <fruitName>",
	"pregnancyTool.title": "Minggu kehamilan anda",
	"pregnancyTool.weightSuggested": "Berat yang disarankan",
	"pregnancyWeightGain.havingTwins": "Anda hamil anak kembar?",
	"pregnancyWeightGain.heading": "Pertambahan Berat Badan Kehamilan",
	"pregnancyWeightGain.heightInput": "Berapa tinggi badan anda?",
	"pregnancyWeightGain.weekInput": "Berapa minggu kehamilan anda?",
	"pregnancyWeightGain.weightBeforeInput": "Berapa berat badan anda sebelum hamil?",
	"pregnancyWeightGain.weightInput": "Berapa berat badan anda sekarang?",
	"pregnancyWeightGain.weightInput.desc": "(kg)",
	"pregnancyWeightGain.weightInput.error": "Sila nyatakan berat badan anda",
	"previewPhotos.title": "Kiriman {name}",
	"profilePanel.anserwing.viewFull": "Lihat jawapan penuh",
	"profilePanel.awards": "Anugerah & Akreditasi ",
	"profilePanel.createPost": "Buat pos",
	"profilePanel.education": "Pendidikan",
	"profilePanel.emptyCareMess.content": "Kelihatan tiada soalan untuk doktor pada masa ini. Terima kasih kerana menjadi sebahagian daripada komuniti kami.",
	"profilePanel.emptyPostMess.content": "{name} belum terlibat dalam sebarang aktiviti akhir-akhir ini.",
	"profilePanel.experience": "Pengalaman",
	"profilePanel.joined": "Telah sertai",
	"profilePanel.modal.heading": "Profil",
	"profilePanel.publishcation": "Penerbitan",
	"profilePanel.publishedArticles": "Artikel Di Hello Doktor",
	"profilePanel.question": "Soalan",
	"profilePanel.questionNotClear": "Soalan kurang jelas",
	"profilePanel.skipQuestion.content": "Kami akan buang soalan ini dari senarai anda",
	"profilePanel.skipQuestion.heading": "Langkaui Soalan ini",
	"profilePanel.socialLinks": "Pautan sosial",
	"profilePanel.tabs.care": "Pertanyaan",
	"profilePanel.tabs.expertAnswer": "Jawapan Pakar",
	"profilePanel.tabs.highlight": "Kelayakan & Pencapaian",
	"profilePanel.tabs.posts": "Pos",
	"profilePanel.tabs.relevantArticles": "Artikel Berkaitan",
	"pwg.placeholder.height": "Tinggi anda",
	"pwg.placeholder.weight": "Berat anda",
	"pwgForm.week": "minggu",
	"sensitiveMask.blur": "Kaburkan",
	"sensitiveMask.contentWarningDescription": "Amaran: Paparan berikut mungkin menimbulkan rasa kurang senang bagi sesetengah individu.  ",
	"sensitiveMask.contentWarningDescription.community": "Amaran: Gambar ini mungkin mengganggu.",
	"sensitiveMask.contentWarningMessage": "Paparan gambar mungkin kurang menyenangkan",
	"sensitiveMask.unblur": "Paparkan",
	"share.by": "Kongsi melalui",
	"share.copyLink": "Atau salin pautan",
	"share.letsJoinCommunity": "Mari sertai komuniti {name}!",
	"share.letsJoinTopic": "Mari sertai topik {name} !",
	"share.linkCopied": "Pautan Disalin",
	"share.linkShared": "Pautan Berjaya Dikongsi",
	"share.title": "Kongsikan",
	"shareContainer.title": "Kongsikan keputusan",
	"similac.thankYou.done": "Siap",
	"ssov2.abTestingFlowB.description": "Daftar atau log masuk dengan e-mel atau akaun media sosial anda.",
	"ssov2.button.cancel": "Batal",
	"ssov2.button.continue": "Sambung",
	"ssov2.button.continueGoogle": "Continue with Google",
	"ssov2.button.continueSMS": "Sambung denang SMS",
	"ssov2.button.continueWhatsApp": "Sambung dengan Whatsapp",
	"ssov2.button.continueZalo": "Sambung dengan Whatsapp",
	"ssov2.button.exitNow": "Saya mahu keluar sekarang",
	"ssov2.button.otp.sms": "Hantarkan Kod OTP melalui SMS",
	"ssov2.button.otp.whatsapp": "Hantarkan Kod OTP melalui WhatsApp",
	"ssov2.button.otp.zalo": "Hantarkan Kod OTP melalui Zalo",
	"ssov2.button.save": "Simpan",
	"ssov2.button.setupLater": "Tetapkan kemudian",
	"ssov2.collectInfo.why": "Mengapa kami perlukan informasi anda?",
	"ssov2.email.alreadyUsed": "E-mel ini sudah digunakan, sila masukkan e-mel berbeza",
	"ssov2.email.button": "Sahkan E-mel anda",
	"ssov2.email.description": "Gunakan e-mel anda untuk log masuk atau daftar",
	"ssov2.email.title": "Teruskan dengan e-mel",
	"ssov2.error.api": "Kesilapan API",
	"ssov2.error.api.000": "Beberapa Masalah Berlaku",
	"ssov2.error.api.001": "E-mel haruslah alamat e-mel yang disahkan",
	"ssov2.error.api.002": "Ruangan e-mel perlu diisi",
	"ssov2.error.api.003": "Ahli ini tidak wujud dalam sistem",
	"ssov2.error.api.004": "Alamat e-mel tidak boleh melebihi 255 karakter",
	"ssov2.error.api.005": "Ruangan nombor telefon perlu diisi",
	"ssov2.error.api.006": "Nombor telefon mesti mengandungi minimum 8 karakter",
	"ssov2.error.api.007": "Nombor telefon ini sudah dipautkan ke profil anda",
	"ssov2.error.api.008": "Ruangan Kod OTP perlu diisi",
	"ssov2.error.api.009": "Pengguna tidak dikemaskinikan",
	"ssov2.error.api.010": "Pengesahan OTP gagal",
	"ssov2.error.api.011": "Nama mesti dalam bentuk teks",
	"ssov2.error.api.012": "Nama tidak boleh melebihi 100 karakter.",
	"ssov2.error.api.013": "Nama pengguna mesti dalam bentuk teks",
	"ssov2.error.api.014": "Nama pengguna telah diambil",
	"ssov2.error.api.015": "Nama pengguna tidak boleh melebihi 20 karakter",
	"ssov2.error.api.016": "Tarikh lahir tidak mengikut format tahun-bulan-hari",
	"ssov2.error.api.017": "Ruangan Avatar harus diisi",
	"ssov2.error.api.018": "Avatar harus dalam format gambar",
	"ssov2.error.api.019": "Avatar harus dalam format jpeg, jpg, png, gif.",
	"ssov2.error.api.020": "Fail Avatar tidak boleh melebihi 10240 KB.",
	"ssov2.error.api.021": "Ruangan kata laluan diperlukan",
	"ssov2.error.api.022": "Kata laluan harus mengandungi sekurang-kurangya 8 karakter",
	"ssov2.error.api.023": "Format kata laluan tidak sah",
	"ssov2.error.api.024": "Kata laluan yang disahkan tidak boleh melebihi 50 karakter",
	"ssov2.error.api.025": "Ruangan kata laluan baharu  harus diisi",
	"ssov2.error.api.026": "Kata laluan baharu tidak boleh kurang dari 8 karakter",
	"ssov2.error.api.027": "Format kata laluan baharu tidak sah",
	"ssov2.error.api.028": "Kata laluan baharu tidak boleh melebihi 50 karakter",
	"ssov2.error.api.029": "Kata laluan anda tidak sepadan. Sila cuba lagi",
	"ssov2.error.api.030": "Kata laluan baharu harus berbeza dengan kata laluan semasa",
	"ssov2.error.api.031": "Ruangan kata laluan baharu  harus diisi",
	"ssov2.error.api.032": "Ruangan kata laluan baharu yang disahkan harus diisi",
	"ssov2.error.api.033": "Kata laluan baharu dan kata laluan yang disahkan harus sepadan",
	"ssov2.error.api.034": "Kata laluan baharu yang disahkan tidak boleh kurang dari 8 karakter",
	"ssov2.error.api.035": "Kata laluan baharu tidak boleh kurang dari 8 karakter",
	"ssov2.error.api.036": "Kata laluan baharu yang disahkan tidak boleh melebihi 50 karakter",
	"ssov2.error.api.037": "Kata laluan baharu tidak boleh melebihi 50 karakter",
	"ssov2.error.api.038": "Kata laluan semasa tidak betul!",
	"ssov2.error.api.039": "Ruangan kata laluan perlu diisi",
	"ssov2.error.api.040": "Token Tandatangan tidak dapat disahkan",
	"ssov2.error.api.041": "Token telah luput",
	"ssov2.error.api.042": "Ruangan refresh token perlu diisi.",
	"ssov2.error.api.043": "Ruangan poskod perlu diisi",
	"ssov2.error.api.044": "E-mel telah digunakan",
	"ssov2.error.api.045": "Kod pengesahan OTP e-mel gagal",
	"ssov2.error.api.046": "Ruangan kod perlu diisi",
	"ssov2.error.api.047": "Nombor telefon ini telah digunakan",
	"ssov2.error.api.048": "Nombor telefon ini tidak sepadan dengan nombor telefon yang telah didaftar",
	"ssov2.error.api.049": "Pengguna tidak wujud",
	"ssov2.error.api.050": "Website id perlu diisi",
	"ssov2.error.api.051": "Ruangan nama perlu diisi",
	"ssov2.error.api.052": "Ruangan tarikh lahir perlu diisi",
	"ssov2.error.api.053": "Ruangan jantina perlu diisi",
	"ssov2.error.api.054": "Ruangan pemberi perkhidmatan perlu diisi",
	"ssov2.error.api.055": "Ruangan token perlu diisi",
	"ssov2.error.api.056": "Kod telah dihantar ke alamat e-mel anda",
	"ssov2.error.api.057": "Alamat e-mel tidak wujud",
	"ssov2.error.api.058": "Anda mengesahkan nombor telefon yang bukan milik anda",
	"ssov2.error.api.059": "Nombor telefon tidak sah",
	"ssov2.error.api.060": "Nombor telefon ini bukan ahli",
	"ssov2.error.api.061": "Nombor telefon ini sudahpun dipautkan dengan profil anda",
	"ssov2.error.api.062": "Kesilapan ZNS dengan msg_id hilang",
	"ssov2.error.api.063": "Tiada pengesahan OTP",
	"ssov2.error.api.064": "Tarikh luput haruslah tarikh selepas 5 minit",
	"ssov2.error.api.065": "Kod yang dipilih tidak sah",
	"ssov2.error.api.066": "Kesilapan ketika mengemas kini penjejakan ZNS",
	"ssov2.error.api.067": "OTP Whatsapp yang dihantar gagal",
	"ssov2.error.api.068": "Tarikh luput haruslah tarikh selepas 10 minit",
	"ssov2.error.api.069": "Kod harus sekurang-kurangya 6 karakter",
	"ssov2.error.api.070": "Kod tidak boleh melebihi 10 karakter",
	"ssov2.error.api.071": "Anda telah mencapai had 3 percubaan pengesahan dalam masa 1 jam. Sila tunggu dan cuba lagi kemudian",
	"ssov2.error.api.072": "Anda telah mencapai had 5 percubaan pengesahan hari ini. Sila cuba lagi esok",
	"ssov2.error.api.073": "Kata laluan haru mengandungi sekurang-kurangya 8 karakter",
	"ssov2.error.api.074": "Format kata laluan tidak sah",
	"ssov2.error.api.075": "Format Kata laluan yang disahkan tidak sah",
	"ssov2.error.api.076": "Kata laluan mesti mengandungi sekurang-kurangnya satu nombor.",
	"ssov2.error.api.077": "Kata laluan yang disahkan mesti mengandungi sekurang-kurangnya satu nombor.",
	"ssov2.error.api.078": "E-mel telah wujud dalam sistem",
	"ssov2.error.api.079": "Terlalu banyak mesej",
	"ssov2.error.api.080": "Kod OTP yang dipilih tidak sah",
	"ssov2.error.api.082": "The password must contain at least one uppercase and one lowercase letter.",
	"ssov2.error.api.083": "Sent Whatsapp OTP failed",
	"ssov2.error.facebookLogin": "Daftar masuk Facebook tidak berjaya",
	"ssov2.error.googleLogin": "Gagal log masuk menggunakan Google",
	"ssov2.first.country.code": "Kod panggilan negara",
	"ssov2.first.description": "Teruskan dengan nombor telefon, e-mel atau media sosial anda untuk log masuk atau mendaftar.",
	"ssov2.first.noAccountOrPass": "Anda tiada akaun atau perlu menetapkan kata laluan, sila teruskan pendaftaran",
	"ssov2.first.search.country.all": "Semua negara",
	"ssov2.first.search.country.placeholder": "Cari negara/wilayah",
	"ssov2.first.search.country.selected": "Pilihan semasa",
	"ssov2.first.title.login": "Daftan masuk",
	"ssov2.first.title.signup": "Daftar",
	"ssov2.orContinueWith": "atau teruskan dengan",
	"ssov2.otp.email.description": "Masukkan kod OTP 6-digit yang dihantar ke e-mel <b>{email}</b>. Kod OTP akan tamat tempoh dalam masa <b>10 minit</b>",
	"ssov2.otp.email.title": "Sahkan E-mel anda",
	"ssov2.otp.phone.description": "Masukkan kod OTP 6-digit yang dihantar ke nombor telefon anda <b>{phone}</b> melalui <b>{method}</b>. Kod OTP akan tamat tempoh dalam masa <b>10 minit</b>",
	"ssov2.otp.phone.title": "Sahkan nombor telefon anda",
	"ssov2.otp.resendQuestion": "Tidak menerima kod?",
	"ssov2.otp.resendText": "Hantar semula ({count}s)",
	"ssov2.otp.sendVia": "Hantar Kod OTP melalui {method}",
	"ssov2.password.description": "Log masuk dengan kata laluan anda",
	"ssov2.password.forgotPassword": "Lupa kata laluan?",
	"ssov2.password.reset": "Tetapkan semula",
	"ssov2.password.signIn": "Log masuk",
	"ssov2.password.title1": "Selamat kembali!",
	"ssov2.password.title2": "Masukkan kata laluan anda",
	"ssov2.passwordForgotSetup.description": "Tetapkan kata laluan log masuk dan butiran lain anda untuk melengkapkan proses pendaftaran.",
	"ssov2.passwordForgotSetup.field.password.atLeast8Chars": "Mesti mengandungi minimum 8 karakter",
	"ssov2.passwordForgotSetup.field.password.atLeastOneUpper": "Mesti mengandungi minimum satu huruf besar, satu huruf kecil, dan satu nombor",
	"ssov2.passwordForgotSetup.field.password.label": "kata laluan",
	"ssov2.passwordForgotSetup.field.password.placeholder": "Masukkan kata laluan anda",
	"ssov2.passwordForgotSetup.field.passwordConfirm.label": "Sahkan kata laluan",
	"ssov2.passwordForgotSetup.field.passwordConfirm.placeholder": "Sahkan kata laluan",
	"ssov2.passwordForgotSetup.title": "Tetapkan kata laluan anda",
	"ssov2.phone.alreadyUsed": "Nombor ini sudah digunakan, sila masukkan nombor berbeza",
	"ssov2.phoneVerify.description": "Sila berikan maklumat tambahan untuk melengkapkan proses pendaftaran akaun.",
	"ssov2.phoneVerify.title": "Sahkan nombor telefon anda",
	"ssov2.policyText": "Dengan mendaftar, saya mengesahkan bahawa saya telah membaca, memahami dan bersetuju dengan {privacy} dan {terms} Hello Health Group. Saya bersetuju untuk menyertai HelloDoktor, dan saya bersetuju untuk Hello Health Group mengumpul, menyimpan, menggunakan, mendedahkan, dan memproses maklumat saya mengikut Dasar Privasi Hello Health Group. Tambahan pula, saya bersetuju untuk Hello Health Group menggunakan maklumat saya untuk menghantar maklumat promosi (termasuk melalui surat, e-mel, telefon, dan pesanan teks) atau menghubungi saya mengenai produk, perkhidmatan, program atau topik lain yang mungkin menarik minat saya mengikut Hello Health Group; dan Hello Health Group boleh berkongsi maklumat saya kepada rakan kongsi dan pelanggannya agar mereka dapat memberikan perkhidmatan dan maklumat promosi yang lebih membantu.\"",
	"ssov2.policyText.community": "Dengan mendaftar, saya mengesahkan bahawa saya telah membaca, memahami dan bersetuju dengan {privacy} dan {terms} Hello Health Group. Saya bersetuju untuk menyertai komuniti HelloDoktor, dan saya bersetuju untuk Hello Health Group mengumpul, menyimpan, menggunakan, mendedahkan, dan memproses maklumat saya mengikut Dasar Privasi Hello Health Group. Tambahan pula, saya bersetuju untuk Hello Health Group menggunakan maklumat saya untuk menghantar maklumat promosi (termasuk melalui surat, e-mel, telefon, dan pesanan teks) atau menghubungi saya mengenai produk, perkhidmatan, program atau topik lain yang mungkin menarik minat saya mengikut Hello Health Group; dan Hello Health Group boleh berkongsi maklumat saya kepada rakan kongsi dan pelanggannya agar mereka dapat memberikan perkhidmatan dan maklumat promosi yang lebih membantu.\"",
	"ssov2.policyText.privacy": "Dasar Privasi",
	"ssov2.policyText.terms": "Syarat Perkhidmatan",
	"ssov2.popup.close.description": "Anda hampir selesai menyediakan akaun. Adakah anda pasti mahu keluar?",
	"ssov2.popup.close.title": "Adakah anda pasti ingin keluar?",
	"ssov2.resetPassword.description": "Sila masukkan nombor telefon yang anda gunakan untuk mencipta akaun anda.",
	"ssov2.resetPassword.title": "Ubah kata laluan",
	"ssov2.setup.button.createAccount": "Daftar akaun baharu",
	"ssov2.setup.button.veriyPhone": "Sahkan nombor telefon",
	"ssov2.setup.description": "Sila berikan maklumat tambahan untuk melengkapkan proses pendaftaran akaun.",
	"ssov2.setup.field.dob.label": "Tarikh lahir",
	"ssov2.setup.field.dob.placeholder": "Masukkan tarikh lahir anda",
	"ssov2.setup.field.email.label": "E-mel",
	"ssov2.setup.field.gender.female": "Perempuan",
	"ssov2.setup.field.gender.label": "Jantina",
	"ssov2.setup.field.gender.male": "Lelaki",
	"ssov2.setup.field.name.label": "Nama",
	"ssov2.setup.field.name.placeholder": "Masukkan nama anda",
	"ssov2.setup.field.otp.label": "Terima OTP melalui",
	"ssov2.setup.field.phone.label": "Nombor telefon",
	"ssov2.setup.title": "Hampir siap!",
	"ssov2.updateEmail.button": "Sahkan E-mel anda",
	"ssov2.updateEmail.description": "Sila kemas kini dan sahkan e-mel anda untuk terus menggunakan perkhidmatan kami.",
	"ssov2.updateEmail.title": "Kemaskini E-mel",
	"ssov2.useOtherMethod.email": "Akaun ini tidak membolehkan log masuk dengan e-mel. Sila pilih kaedah log masuk yang lain",
	"ssov2.useOtherMethod.phone": "Akaun ini tidak membolehkan log masuk dengan nombor telefon. Sila pilih kaedah log masuk yang lain",
	"ssov2.validate.confirmPassword.match": "Kata laluan harus sepadan",
	"ssov2.validate.confirmPassword.required": "Pengesahan kata laluan diperlukan",
	"ssov2.validate.dob.required": "Tarikh lahir diperlukan",
	"ssov2.validate.email.invalid": "E-mel tidak sah",
	"ssov2.validate.email.required": "E-mel diperlukan",
	"ssov2.validate.gender.oneOf": "Jantina haruslah lelaki atau perempuan",
	"ssov2.validate.gender.required": "Jantina diperlukan",
	"ssov2.validate.name.required": "Nama diperlukan",
	"ssov2.validate.otp.required": "Cara OTP diperlukan",
	"ssov2.validate.password.required": "Kata laluan diperlukan",
	"ssov2.validate.phone.required": "Nombor telefon diperlukan",
	submit: submit,
	"switchBtn.no": "Tidak",
	"switchBtn.yes": "Ya",
	"tab.about": "Tentang Kami",
	"tab.discussion": "Perbincangan",
	"tab.topic": "Topik",
	"tagTopic.moreTopics": "{number} topik lagi",
	"targetHearRate.heading": "Kalkulator Kadar Degup Jantung Sasaran",
	"targetHeartRate.aerobicZone.note": "Zon aerobik",
	"targetHeartRate.aerobicZone.title": "Zon aerobik",
	"targetHeartRate.ageInput": "Bilakah tarikh lahir anda?",
	"targetHeartRate.ageInput.desc": "(tahun)",
	"targetHeartRate.ageInput.error": "Nyatakan usia sebenar anda",
	"targetHeartRate.heartRateInput": "Berapa kadar degup jantung anda?",
	"targetHeartRate.heartRateInput.desc": "(bpm)",
	"targetHeartRate.heartRateInput.error": "Nyatakan kadar degup jantung rehat anda",
	"targetHeartRate.lowIntensity.note": "Intensiti rendah (sedikit atau tiada senaman)",
	"targetHeartRate.lowIntensity.title": "Intensiti rendah",
	"targetHeartRate.maximumIntensity.note": "Intensiti maksimum (senaman amat berat/sukan atau 2x latihan)",
	"targetHeartRate.maximumIntensity.title": "Intensiti maksimum",
	"targetHeartRate.moderateIntensity.note": "Intensiti sederhana (senaman/sukan 1-3 kali sehari/seminggu)",
	"targetHeartRate.moderateIntensity.title": "Intensiti sederhana",
	"targetHeartRate.optional": "(optional)",
	"targetHeartRate.selectActive": "Berapa aktifkah anda pada setiap hari?",
	"targetHeartRate.vigorousIntensity.note": "Intensiti tinggi (senaman berat/sukan 6-7 kali sehari/seminggu)",
	"targetHeartRate.vigorousIntensity.title": "Intensiti tinggi",
	"tool.askChecking": "Saya semak bagi pihak lain",
	"tool.selectPerson": "Anda memeriksanya untuk siapa?",
	"tool.selectPerson.other": "Orang lain",
	"tool.selectPerson.yourSelf": "Diri sendiri",
	"toolPage.toolReviewer": "Disemak secara perubatan oleh {expert_name} pada {date}",
	"tools.checkYourKidsInput.label": "Adakah anda memeriksa untuk anak anda?",
	"tools.checkYrs": "Adakah anda kira BMI untuk diri sendiri? ",
	"tools.heading.on": "pada",
	"tools.heartRateRangeErr": "Sila masukkan nilai antara {min} - {max} bpm",
	"tools.inputPlaceholder": "Contoh: {content}",
	"tools.requiredErrorMess.age": "Masukkan umur yang sah.",
	"tools.requiredErrorMess.gender": "Sila masukkan jantina",
	"tools.selectBabyGender": "Apa jantina anak anda?",
	"tools.selectGender": "Apakah jantina anda?",
	"tools.yearsOld": "tahun",
	"updatePost.popup.success": "Pos telah dikemas kini dengan jayanya.",
	"userProfile.nav.card.eCom": "E-dagang",
	"userProfile.nav.card.ecom.DeliveryAddress": "Urus alamat",
	"userProfile.nav.card.ecom.manageOrders": "Urus pesanan",
	"userProfile.nav.card.ecom.voucher": "Baucar",
	"userProfile.nav.card.myBooking": "Tempahan saya",
	"userProfile.nav.card.myCommunity": "Komuniti saya",
	"userProfile.nav.card.myFamily": "Profil keluarga",
	"userProfile.nav.card.myHealth": "Kesihatan saya",
	"userProfile.nav.card.mySaved": "Disimpan",
	"userProfile.nav.header.count.comments": "Komen",
	"userProfile.nav.header.count.posts": "Kiriman",
	"userProfile.nav.header.count.tools": "Alatan",
	"userProfile.nav.header.points": "Poin",
	"userProfile.nav.header.viewProfile": "Lihat Profil Saya",
	"userProfile.nav.menu.accountSettings": "Tetapan akaun",
	"userProfile.nav.menu.dataPrivacy": "Privasi Data",
	"userProfile.nav.menu.disableAccount": "Nyahaktif Akaun",
	"userProfile.nav.menu.help": "Bantuan",
	"userProfile.nav.menu.logout": "Log keluar",
	"userProfile.nav.menu.password": "Kata laluan",
	"userProfile.userRank.ambassador": "Duta",
	"userProfile.userRank.doctor": "Doktor",
	"userProfile.userRank.expert": "Pakar",
	"userProfile.userRank.influencer": "Pempengaruh",
	"userProfile.userRank.member": "Ahli",
	"validation.error.requiredAgeGroup": "Soal selidik ini hanya tersedia untuk kanak-kanak berumur 1-6 tahun",
	"validation.error.requiredField": "Bahagian ini wajib diisi",
	"verifyBotAnswer.confirmEndorse.accept": "Ya, sokong",
	"verifyBotAnswer.confirmEndorse.cancel": "Tidak, batal",
	"verifyBotAnswer.confirmEndorse.description": "erima kasih atas sokongan terhadap jawapan ini",
	"verifyBotAnswer.confirmEndorse.heading": "Sokong jawapan ini",
	"footer.followUsText": "Ikuti kami",
	"footer.info.address": "47-1, Jalan SS 18/6, 47500 Subang Jaya, Selangor Malaysia"
};

export { character, copied, copy, msTranslations as default, insert, loading, orCopyLink, submit };
